import { HttpParams } from '@angular/common/http';

import { Filter } from '../../../../models';

/** Representa o Filter da entidade UnidadeNegocioNaturezaVenda */
export class UnidadeNegocioNaturezaVendaFilter implements Filter {
    situacaoNaturezaVenda: number;
    situacoesNaturezasVendas: number[] = [];

    /** Cria os parâmetros do filtro */
    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Situação da Natureza de Venda
        if (this.situacaoNaturezaVenda) {
            params = params.append('situacaoNaturezaVenda', this.situacaoNaturezaVenda.toString());
        }
        this.situacoesNaturezasVendas?.forEach(situacaoNaturezaVenda => {
            params = params.append('situacaoNaturezaVenda', situacaoNaturezaVenda.toString());
        })

        return params;
    }

    clear() {
        this.situacaoNaturezaVenda = null;
        this.situacoesNaturezasVendas = [];
    }
}

